import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface RentRemoveConfirmDialogProps {
  open: boolean;
  onClose?: () => void;
  onAccept?: () => void;
  onDeny?: () => void;
  isLoading?: boolean;
}

export const RentRemoveConfirmDialog = ({
  onDeny,
  onClose,
  onAccept,
  open,
  isLoading
}: RentRemoveConfirmDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle id="alert-dialog-title">Odstranění zápůjčky</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Opravdu chcete smazat tento záznam? Tento krok nelze vzít zpět.
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          py: 4,
          justifyContent: 'center',
          flexDirection: { xs: 'column-reverse', md: 'row' },
          gap: 2
        }}
      >
        <Button onClick={onDeny}>Zavřít</Button>
        <Button autoFocus variant="contained" color="error" onClick={onAccept} loading={isLoading}>
          Smazat záznam
        </Button>
      </DialogActions>
    </Dialog>
  );
};
